import { useTranslation } from 'react-i18next'

import { cn } from '#/shared/lib/utils'

import { SETTLE_VIA } from '../model/use-settle-payment'
import type { SettleVia } from '../model/use-settle-payment'

interface PaymentViaTabsProps {
  value: SettleVia
  onChange: (next: SettleVia) => void
}

const TAB_VALUES: ReadonlyArray<SettleVia> = [SETTLE_VIA.card, SETTLE_VIA.other]

export function PaymentViaTabs({ value, onChange }: PaymentViaTabsProps) {
  const { t } = useTranslation()
  return (
    <div className="flex w-full flex-col gap-2">
      <span className="text-xs text-gray-500">
        {t('settlePayment.paymentVia')}
      </span>
      <div role="tablist" className="flex w-full gap-2">
        {TAB_VALUES.map((tab) => {
          const active = tab === value
          return (
            <button
              key={tab}
              type="button"
              role="tab"
              aria-selected={active}
              onClick={() => onChange(tab)}
              className={cn(
                'flex h-10 flex-1 cursor-pointer items-center justify-center rounded-md border px-3 text-sm transition-colors',
                active
                  ? 'border-primary bg-blue-100 font-medium text-primary'
                  : 'border-gray-200 bg-white text-gray-500 hover:bg-gray-50',
              )}
            >
              {t(`settlePayment.via.${tab}`)}
            </button>
          )
        })}
      </div>
    </div>
  )
}
